/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RansomwareRecoveryEdrVendorEnum } from './ransomwareRecoveryEdrVendorEnum';
import { RansomwareRecoveryDeploymentStatesEnum } from './ransomwareRecoveryDeploymentStatesEnum';
import { RansomwareRecoveryProvisionModeEnum } from './ransomwareRecoveryProvisionModeEnum';


export interface RansomwareRecoveryDeployment { 
    /**
     * Ransomware Recovery Deployment ID
     */
    id: string;
    /**
     * Org id
     */
    org_id: string;
    provision_mode?: RansomwareRecoveryProvisionModeEnum;
    edr_vendor?: RansomwareRecoveryEdrVendorEnum;
    state: RansomwareRecoveryDeploymentStatesEnum;
    /**
     * AWS region
     */
    aws_region: string;
    /**
     * CarbonBlack child Org Id
     */
    cb_child_org_id?: string;
    /**
     * Activated CBC Geo POP region
     */
    cb_pop_id: string;
    /**
     * Activation task id
     */
    activation_task_id: string;
    activation_timestamp?: Date;
    /**
     * Group Id generated for org and CBC Geo POP region pair
     */
    activation_group_id: string;
    /**
     * User who created the activation
     */
    activated_by?: string;
    activation_request_list?: Array<object>;
    activation_response_list?: Array<object>;
    activation_status_request_list?: Array<object>;
    activation_status_response_list?: Array<object>;
    api_error_list?: Array<object>;
    /**
     * API key path
     */
    api_key_path?: string;
    /**
     * Created timestamp in UTC
     */
    created_timestamp: Date;
    /**
     * User who accepted the deactivation
     */
    deactivation_accepted_by?: string;
    /**
     * Deactivation accepted task id
     */
    deactivation_accepted_task_id?: string;
    /**
     * Deactivation accepted timestamp in UTC
     */
    deactivation_accepted_timestamp?: Date;
    deactivation_request_list?: Array<object>;
    /**
     * Request URN sent along with deactivation request when retry
     */
    deactivation_request_urn?: string;
    /**
     * User who requested the deactivation
     */
    deactivation_requested_by?: string;
    /**
     * Deactivation requested task id
     */
    deactivation_requested_task_id?: string;
    /**
     * Deactivation requested timestamp in UTC
     */
    deactivation_requested_timestamp?: Date;
    deactivation_response_list?: Array<object>;
    deactivation_status_request_list?: Array<object>;
    deactivation_status_response_list?: Array<object>;
    /**
     * RWR Activation API version
     */
    deployment_version: string;
    msp_org_groups_details?: Array<object>;
    /**
     * Org country code
     */
    org_country_code?: string;
    /**
     * CarbonBlack child Org Key
     */
    org_key?: string;
    /**
     * Request URN sent along with activation request when retry
     */
    request_urn?: string;
    /**
     * User who request the activation
     */
    requested_by?: string;
    /**
     * Updated timestamp in UTC
     */
    updated_timestamp?: Date;
}
export namespace RansomwareRecoveryDeployment {
}


